import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {getBowserState} from '@epic-core/common';

export default class SectionText extends Component {
    static propTypes = {
        text: PropTypes.string,
        className: PropTypes.string,
        animate: PropTypes.bool,
        bkWidth: PropTypes.number
    };

    state = {
        animated: false
    };

    words = [];

    animateText = () => {
        const {mobile, tablet} = getBowserState();
        const {words} = this;
        if (
            !this.state.animated &&
            words.length > 1 &&
            !mobile &&
            !tablet &&
            this.props.bkWidth > 1026
        ) {
            const wordArray = [];
            for (let x = 0; x < words.length; x++) {
                if (words[x]) {
                    wordArray.push(words[x]);
                }
            }

            this.setState({animated: true});
            TweenMax.staggerFromTo(
                wordArray,
                1,
                {
                    rotation: 10,
                    yPercent: '100%',
                    autoAlpha: 0,
                    delay: 0.1
                },
                {
                    rotation: 0,
                    yPercent: '0',
                    autoAlpha: 1,
                    delay: 0.1,
                    clearProps: 'all'
                },
                0.2
            );
        }
    };

    UNSAFE_componentWillReceiveProps(props) {
        if (props.animate && !this.state.animated && props.text !== null) {
            this.animateText();
        } else if (!props.animate) {
            this.setState({animated: false});
        }
    }

    render() {
        const textString = this.props.text || '';
        const words = textString.split(' ') || '';
        const contents = [];

        for (let i = 0; i < words.length; i++) {
            const word = words[i];
            contents.push(
                <p
                    ref={(c) => {
                        this.words[i] = c;
                    }}
                    key={`word-${i}`}>
                    <span>{word}</span>
                </p>
            );
        }

        return (
            <div className={`section-text ${this.props.className} word-amount-${words.length}`}>
                {contents}
            </div>
        );
    }
}
